import type React from 'react'

import { ItemHeader } from '@/components/Style/Common'

interface Props {
  header: string
}

const InformationItem: React.FC<Props> = ({ children, header }) => {
  return (
    <div>
      <ItemHeader>{header}</ItemHeader>
      <p>{children}</p>
    </div>
  )
}

export default InformationItem
